import { Box, Group, Text } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { FaCaretDown, FaCaretUp } from 'react-icons/fa'
import { PastDrivesTimeline } from './PastDrivesTimeline'
import { VehicleResponse, RouteResponse } from '@/api/main/types.gen'
import { DrivesByStateByVehicle } from '@/utils/scheduling'
import dayjs from 'dayjs'
import IconButton from '../Common/IconButton'
import { useTranslation } from 'react-i18next'

export function PastDrivesSection({
  dayDrivesData,
  vehicles,
  routes,
}: {
  dayDrivesData: Array<{ drives: DrivesByStateByVehicle; timelineStart: dayjs.Dayjs }>
  vehicles: Array<VehicleResponse>
  routes?: RouteResponse[]
}) {
  const { t } = useTranslation('scheduling')
  const [isPastDrivesOpen, { toggle: togglePastDrives }] = useDisclosure(false)
  const hasPastDrives = dayDrivesData.length > 0

  if (!hasPastDrives) {
    return null
  }

  return (
    <Box
      style={{
        gridColumnStart: 1,
        gridColumnEnd: vehicles.length + 1,
      }}
    >
      <Group gap="xs" mb="md" align="center">
        <IconButton
          label={isPastDrivesOpen ? t('collapsePastDrives') : t('expandPastDrives')}
          onClick={togglePastDrives}
          icon={isPastDrivesOpen ? <FaCaretDown /> : <FaCaretUp />}
        />
        <Text fw={600} size="lg" pt="4px">
          {t('pastDrives')}
        </Text>
      </Group>
      <Box style={{ display: isPastDrivesOpen ? 'block' : 'none' }}>
        {dayDrivesData.map(dayData => (
          <PastDrivesTimeline
            key={dayData.timelineStart.format('YYYY-MM-DD')}
            drives={dayData.drives}
            vehicles={vehicles}
            timelineStart={dayData.timelineStart}
            routes={routes}
          />
        ))}
      </Box>
    </Box>
  )
}
